export const Link = {
    baseStyle: {
        color: "brand.mediumBlue",
        _hover: {
            color: "brand.lightBlue",
            textDecoration: "underline"
        }
    }
}